import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { InternalGa4Actions } from '../actions'
import { fetchReport } from './fetchReport'

// Сброс серверного кэша — вспомогательный шаг: если он не удался (старый
// бэкенд без роута, сеть), отчёт всё равно перечитываем. Ошибку здесь нельзя
// превращать в reportFailed: он чистит pages, и все ушки исчезают.
function* dropServerCache(projectId: string) {
  try {
    yield call(API.GoogleAnalytics.refresh, projectId)
  } catch {
    // отчёт ниже вернёт то, что есть в кэше
  }
}

export function* resync() {
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  yield put(InternalGa4Actions.resyncing(true))

  try {
    yield call(dropServerCache, projectId)
    yield call(fetchReport)
  } finally {
    yield put(InternalGa4Actions.resyncing(false))
  }
}
